import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

const API_URL_VIVENU = environment.apiUrlVivenu;

@Injectable({
  providedIn: 'root'
})
export class VivenuService {

  constructor(
    private http: HttpClient
  ) { }

  getVivenuCustomer(hubspotCustomerId: number) {
    return this.http.get(API_URL_VIVENU + 'vivenu-customer?hubspotCustomerId=' + hubspotCustomerId, { responseType: 'json' });
  }

  updateVivenuCustomer(vivenuCustomerId: number, update: any) {
    return this.http.put(API_URL_VIVENU + 'vivenu-customer/' + vivenuCustomerId, update, { responseType: 'json' });
  }

  useVivenuApiKey(vivenuApiKey: string, vivenuCustomerId: number) {
    return this.http.post(API_URL_VIVENU + 'vivenu-customer/use-key', {
      apiKey: vivenuApiKey,
      id: vivenuCustomerId
    }, { responseType: 'json'});
  }

  activateVivenuIntegration(vivenuCustomerId: number, active: boolean) {
    return this.http.put(API_URL_VIVENU + 'vivenu-customer/' + vivenuCustomerId + '/activate-integration',
      { active }, { responseType: 'json' });
  }

  activateVivenuSync(vivenuCustomerId: number, active: boolean, type: string) {
    return this.http.put(API_URL_VIVENU + 'vivenu-customer/' + vivenuCustomerId + '/activate-sync',
      { active, type }, { responseType: 'json' });
  }

  migrateVivenuData(vivenuCustomerId: number, type: string, timeRange: string) {
    return this.http.post(API_URL_VIVENU + 'vivenu-sync/' + vivenuCustomerId + '/migrate', {
      type,
      timeRange
    }, { responseType: 'json'});
  }

}
